module.exports = "/_next/static/images/logo-ba28afa95a6b52e7075a9c1dad8a111a.png";